import Phaser from 'phaser';

import { calculateSpeed, GhostAI } from './GhostAI';
import Hero from '../Hero';
import Ghost from '../Ghost';

import { tileSize } from '~/src/consts/sizes';

export default class PlayfullyChaseHeroAI implements GhostAI {
	private readonly hero: Hero;
	private readonly ghost: Ghost;
	public speed = 0;

	get targetPosition() {
		if (new Phaser.Math.Vector2(this.hero).distance(this.ghost) >= 8 * tileSize) {
			return { x: this.hero.x, y: this.hero.y };
		} else {
			return this.ghost.scareAI.targetPosition;
		}
	}

	constructor(hero: Hero, ghost: Ghost) {
		this.hero = hero;
		this.ghost = ghost;
		this.speed = (calculateSpeed(this.ghost.level - 1)) * tileSize;
	}

	chooseTarget() {
		return;
	}
}
